'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpgradeLink = undefined;

var _productProperties = require('ui-addon-upgrades/_core/common/constants/productProperties');

var _productProperties2 = _interopRequireDefault(_productProperties);

var _links = require('ui-addon-upgrades/_core/common/navigation/links');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {Object} upgradeData
 * @return {String}
 */

var getUpgradeLink = exports.getUpgradeLink = function getUpgradeLink(_ref) {
  var source = _ref.source,
      upgradeProduct = _ref.upgradeProduct;

  if (!upgradeProduct) {
    return (0, _links.productsAndAddons)();
  }

  var upgradeLink = _productProperties2.default[upgradeProduct].upgradeLink;


  if (upgradeLink) {
    return upgradeLink(source, upgradeProduct);
  }

  return (0, _links.productsAndAddons)();
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/adapters/getUpgradeLink.js
// module id = 209
// module chunks = 3 4 5